import { Box, Grid, Typography } from "@mui/material";
import noDataFound from "../../assets/images/no-data-found.png";

export function EmptyDataImg({ error = "" }) {
  return (
    <Grid
      container
      direction="column"
      justifyContent={"center"}
      alignItems="center"
      alignContent={"center"}
    >
      <Box
        display={"flex"}
        alignItems="center"
        justifyContent={"center"}
        flexDirection="column"
      >
        <img
          height="auto"
          width="100%"
          src={noDataFound}
        />
        <Typography color={(theme) => theme.palette.text.secondary}>
          {error || "No record found"}
        </Typography>
      </Box>
    </Grid>
  );
}

export * from "./header";
export * from "./sidebar";
